import React from "react";
import PropTypes from "prop-types";
import { Stack, Typography, CardActions, Button, Box, Card } from "@mui/material";
import { Link } from "react-router-dom/dist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Error({
    error = null,
    errorDescription = "Something is not right.",
    secondaryDescription = null,
    path = "/",
    buttonText = "Go Home"
}) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh"
            }}>
            <Card
                sx={{
                    maxWidth: { xs: "95vw", lg: "35vw" },
                    maxHeight: "70vh",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    padding: { xs: "30px", lg: "70px" },
                    borderRadius: "10px",
                    boxShadow: {
                        xs: "0",
                        lg: "2"
                    }
                }}>
                <Box mb={4}>
                    <FontAwesomeIcon
                        icon="fa-solid fa-circle-exclamation"
                        style={{ fontSize: "4rem", color: "#003366" }}
                    />
                </Box>
                <Stack spacing={3} mb={3} width={"100%"}>
                    <Typography variant="h4" component="div">
                        We are sorry, an error occured.
                    </Typography>
                    {error && <Typography variant="h5">{error}</Typography>}
                    <Typography variant="h6">{errorDescription}</Typography>
                    {secondaryDescription && <Typography variant="body1">{secondaryDescription}</Typography>}
                </Stack>
                <CardActions>
                    <Button variant="contained" component={Link} to={path}>
                        {buttonText}
                    </Button>
                </CardActions>
            </Card>
        </Box>
    );
}

Error.propTypes = {
    error: PropTypes.string,
    errorDescription: PropTypes.string,
    secondaryDescription: PropTypes.string,
    path: PropTypes.string,
    buttonText: PropTypes.string
};

export default Error;
